import { type FC, type ReactNode } from "react";
import {
  AppBar,
  Divider,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface StreamDialogHeaderProps {
  title: string;
  onClose: () => void;
  children?: ReactNode;
}

// Порт референсного partner/components/DialogHeader: каждая вкладка формы
// стрима рендерит СВОЙ fixed-хедер со своими экшенами (как Edit/Broadcast/
// Restream в референсе), а табы и отступ контента живут в шелле StreamForm.
export const StreamDialogHeader: FC<StreamDialogHeaderProps> = ({
  title,
  onClose,
  children,
}) => (
  <AppBar color="default" position="fixed" elevation={0}>
    <Toolbar>
      <IconButton edge="start" onClick={onClose} sx={{ mr: 1 }}>
        <CloseIcon />
      </IconButton>
      <Typography variant="h6" noWrap sx={{ flex: 1, mr: 1 }}>
        {title}
      </Typography>
      {children}
    </Toolbar>
    <Divider />
  </AppBar>
);
